import { useStore as n } from "@tanstack/react-store";
import { useGuideContext as c } from "./useGuideContext.mjs";
const p = (e) => {
  const r = c();
  if (!e.key && !e.type)
    throw new Error("useGuide must be used with at least one filter: either a guide key or a guide type");
  const {
    client: t,
    colorMode: i
  } = r, [o] = n(t.store, (s) => t.select(s, e)), u = o && o.steps.find((s) => !s.message.archived_at);
  return {
    client: t,
    colorMode: i,
    guide: o,
    step: u
  };
};
export {
  p as useGuide
};
//# sourceMappingURL=useGuide.mjs.map
